import React from 'react';
import { CccisdWysiwyg, Field } from 'cccisd-formik';

const Html = () => {
    return <Field name="htmlContent" label="Content" component={CccisdWysiwyg} type="textarea" />;
};

export default Html;
